import TypeVehicule from "../TypeVehicule/TypeVehicule";
import MarqueVehiculeContainer from "../MarqueVehicule/MarqueVehiculeContainer.js";
import CylindreeVehiculeContainer from "../CylindreeVehicule/CylindreeVehiculeContainer.js";
import ModeleVehiculeContainer from "../ModeleVehicule/ModeleVehiculeContainer.js";
import DateMec from "./DateMEC/DateMEC";
import _ from "lodash";
import {
    VehiculeImmatricule,
    UsageNonLivraison,
    ValeurVehicule,
    Assure3DerniersMois,
    CarteGriseFrancaise,
    UsageVehicule,
    AssuranceAuto,
    InformationsAssuranceAuto,
    AssuranceMoto,
    InformationsAssuranceMoto,
    ValeurCrmMoto,
    ValeurCrmAuto, TitulaireCarteGrise, SearchByImmat
} from "@amo/core/components/questions";
import ChoixPermis from "./ChoixPermis/ChoixPermis.jsx";
import ContratNomSociete from "../ChangementUsage/ContratNomSociete/ContratNomSociete.jsx";
import {useEffect} from "react";
import InformationsVehicule from "../InformationsVehicule/InformationsVehicule.jsx";
import {getInformationVehicule} from "@amo/core/utils/index.js";
import DateAchat from "./DateAchat/DateAchat.jsx";
import {AssuranceTransitoire} from "./AssuranceTransitoire/AssuranceTransitoire.jsx";
import CrmMoto50Plus3Ans from "../../Antecedents/CrmMoto50Plus3Ans/CrmMoto50Plus3Ans.jsx";
import CrmAuto50Plus3Ans from "../../Antecedents/CrmAuto50Plus3Ans/CrmAuto50Plus3Ans.jsx";

const ChangementVehicule = (props) => {
    const { data, id, source, changeValue, vehicule, codeProduit, formInitialValues, apporteur1 } = props;

    useEffect(() => {
        changeValue('typeVehicule', null)
        changeValue('marqueVehicule', null)
        changeValue('cylindreeVehicule', null)
        changeValue('DemandeTarif[Vehicule][Immatriculation]', null)
        changeValue('searchBy', 'immatriculation')
    }, [])

    const newVehicleType = _.get(data, 'typeVehicule');
    const oldVehicleType = _.get(formInitialValues, 'typeVehicule');

    const questionCrmMotoPosee = _.includes(['7311_PVE', '7311_PVK', '7311_SC'], codeProduit) &&
        !_.includes(['quad', 'verte', '50'], data?.typeVehicule) &&
        !!_.find(_.get(data, 'DemandeTarif[ListePersonnes][0][ListePermis]'), (permis) => {
            return _.includes(['AM', 'A1', 'A2', 'A', 'B'], permis?.TypePermis);
        });
    const questionCrmAutoPosee = _.includes(['7311_PVE', '7311_PVK', '7311_SC'], codeProduit) &&
        !_.includes(['quad', 'verte', '50'], data?.typeVehicule) &&
        !!_.find(_.get(data, 'DemandeTarif[ListePersonnes][0][ListePermis]'), (permis) => {
            return _.includes(['B'], permis?.TypePermis);
        });

    const shouldDisplayAssuranceTransitoire = () => {
        if (apporteur1.codeBelair === 43397) {
            return true;
        }

        if (apporteur1.codeBelair !== 43397 && source === 'conseiller') {
            if (oldVehicleType === 'moto' && newVehicleType === 'moto') {
                return true;
            }
        }

        return false;
    };

    return (
        <div id={id}>
            <TypeVehicule {...props} />
            {
                data?.searchBy === "modele" ? <>
                    {data?.typeVehicule && <MarqueVehiculeContainer {...props} />}
                    {data?.marqueVehicule && <CylindreeVehiculeContainer {...props} />}
                    {data?.cylindreeVehicule && <ModeleVehiculeContainer {...props} />}
                </> : <SearchByImmat {...props} />
            }
            {vehicule?.sra && getInformationVehicule(vehicule) !== '' && <InformationsVehicule {...props} /> }
            {(_.includes(['moto', 'scooter'], data?.typeVehicule) && _.get(data, 'DemandeTarif[ListeContratsBelair][0][VehiculeBelair][EligibleTransitoire]') && shouldDisplayAssuranceTransitoire())
                && <AssuranceTransitoire {...props} />
            }
            <DateMec {...props} />
            <DateAchat {...props} />

{/*            {
                data?.searchBy === "modele" && <QuestionImmatriculation {...props} />
            }*/}
            <TitulaireCarteGrise {...props} />

            {/* champs caché depuis ajout dateAchat moment(_.get(data, 'DemandeTarif[Vehicule][DateMEC]'), 'DD/MM/YYYY', true) <=
                moment().subtract(3, 'months') && <PossedeVehiculePlus3Mois {...props} />
            */}
            {_.get(data, 'DemandeTarif[Vehicule][PossessionPlusDe3Mois]') === '1' && <Assure3DerniersMois {...props} />}

            {_.includes(['quad', 'verte'], data?.typeVehicule) && (
                <>
                    {/*<ValeurVehicule title={'Quelle est <b>la valeur</b> de votre <b>véhicule</b>&nbsp;?'} {...props} />*/}
                    <VehiculeImmatricule title={'Votre véhicule est-il <b>immatriculé</b>&nbsp;?'} {...props} />
                </>
            )}

            {_.get(data, 'DemandeTarif[Vehicule][VehiculeImmatricule]') === '1' && <CarteGriseFrancaise {...props} />}
            {!_.includes(['quad', 'verte'], data?.typeVehicule) &&
                <>
                    <UsageVehicule title={'A quelle(s) <b>occasion(s)</b> <br/>utilisez-vous <b>votre véhicule</b>&nbsp;?'} {...props} />
                    {((source === 'courtier' || source === 'site') && _.get(data, 'DemandeTarif[Vehicule][UsageVehicule]') === '3') && <ContratNomSociete {...props} />}
                </>
            }

            {data?.cylindreeVehicule === '50' && <UsageNonLivraison {...props} />}

            <ChoixPermis {...props} />
            
            {questionCrmMotoPosee && <ValeurCrmMoto {...props} />}

            {questionCrmMotoPosee && Number(_.get(data, 'DemandeTarif[ListePersonnes][0][ValeurCrmMoto]')) === 0.5 && (
                <CrmMoto50Plus3Ans {...props} />
            )}

            {questionCrmAutoPosee && <ValeurCrmAuto {...props} />}

            {questionCrmAutoPosee && Number(_.get(data, 'DemandeTarif[ListePersonnes][0][ValeurCrmAuto]')) === 0.5 && (
                <CrmAuto50Plus3Ans {...props} />
            )}

            { _.includes(['7311_PVE', '7311_PVK', '7311_SC'], codeProduit)  &&
                !_.includes(['quad', 'verte', '50'], data?.typeVehicule) &&
                _.find(_.get(data, 'DemandeTarif[ListePersonnes][0][ListePermis]'), (permis) => {
                    return _.includes(['B'], permis?.TypePermis);
                }) && <AssuranceAuto {...props} antecedentsSur3ans={false} />}

            {_.get(data, 'assure_auto') === '1' && (
                <InformationsAssuranceAuto {...props} antecedentsSur3ans={false} />
            )}

            { _.includes(['7311_PVE', '7311_PVK', '7311_SC'], codeProduit)  &&
                !_.includes(['quad', 'verte', '50'], data?.typeVehicule) &&
                _.find(_.get(data, 'DemandeTarif[ListePersonnes][0][ListePermis]'), (permis) => {
                    return _.includes(['A', 'A1', 'A2'], permis?.TypePermis);
                }) && <AssuranceMoto {...props} antecedentsSur3ans={false} />}

            {_.get(data, 'assure_moto') === '1' && (
                <InformationsAssuranceMoto {...props} antecedentsSur3ans={false} />
            )}
        </div>
    );
};

export default ChangementVehicule;
